<form #f="ngForm">
    <input type="hidden" name="id" placeholder="id" class="form-control form-control-sm" [(ngModel)]="quote.id">
    <div *ngFor="let statementOfFact of statementOfFacts; let i = index;">
        <div class="form-group row">
            <div class="col-md-12">
                <div class="quote_radio w-90">
                    <label class="p-3"> 
                        <span *ngIf="statementOfFact.description.indexOf('[HORSENAME]') !== -1">
                            {{statementOfFact.description.replace('[HORSENAME]',this.quote.horse_details.name)}}
                        </span>
                        <span *ngIf="statementOfFact.description.indexOf('[POLICY_HOLDER_NAME]') !== -1">
                            {{statementOfFact.description.replace('[POLICY_HOLDER_NAME]',this.quote.policy_holder.first_name + ' ' + quote.policy_holder.last_name)}}
                        </span>
                        <span *ngIf="statementOfFact.description.indexOf('[HORSENAME]') == -1  && statementOfFact.description.indexOf('[POLICY_HOLDER_NAME]') == -1">
                            {{statementOfFact.description}}
                        </span>
                    </label>
                </div>
                <span (click)="helpTextPopup(content,statementOfFact.description)"><i
                        class="mdi mdi-comment-question-outline ml-1"></i></span>
            </div>
        </div>
        <div class="form-group row" *ngIf="statementOfFact.type == 1">
            <div class="col-md-3">
                <mat-radio-group aria-label="Select an option"
                    name="statementOfFact_{{quote.statement_of_facts[i].question_id}}"
                    [(ngModel)]="quote.statement_of_facts[i].response">
                    <div class="quote_radio row mb-3">
                        <div class="col-md-6">
                            <mat-radio-button [value]="1" disabled
                                name="statementOfFact_{{quote.statement_of_facts[i].question_id}}"
                                ngDefaultControl [(ngModel)]="quote.statement_of_facts[i].response">Yes</mat-radio-button>
                        </div>
                        <div class="col-md-6">
                            <mat-radio-button [value]="2" disabled
                                name="statementOfFact_{{quote.statement_of_facts[i].question_id}}"
                                ngDefaultControl [(ngModel)]="quote.statement_of_facts[i].response">No</mat-radio-button>
                        </div>
                    </div>
                </mat-radio-group>
            </div>
        </div>
        <div class="form-group row"> 
            <!-- Old Condition -->
            <!-- *ngIf=" ((quote.statement_of_facts[i].response == 1 && (statementOfFact.show_textbox == 1) && (statementOfFact.id !='4c890e3b-9a87-4f01-9454-4201187a7e60' && statementOfFact.id !='4b890e3b-9a87-4f01-9454-4201187a7e59')) || (quote.statement_of_facts[i].response == 2 && (statementOfFact.show_textbox == 0) && (statementOfFact.id =='4c890e3b-9a87-4f01-9454-4201187a7e60' || statementOfFact.id =='4b890e3b-9a87-4f01-9454-4201187a7e59')))" -->
            <div class="col-md-11"
            *ngIf="((quote.statement_of_facts[i].response == 1 && statementOfFact.show_textbox == 1 && statementOfFact.display_order < 10) || (quote.statement_of_facts[i].response == 2 && statementOfFact.show_textbox == 0  && statementOfFact.display_order >= 10))">
                <textarea name="response_text_{{quote.statement_of_facts[i].question_id}}"
                    class="form-control" placeholder="Please provide response text" readonly
                    [(ngModel)]="quote.statement_of_facts[i].response_text">
                </textarea>
            </div>
        </div>
        <div class="form-group row" *ngIf="statementOfFact.type == 2">
            <div class="col-md-11">
                <input class="form-control" type="text" placeholder="Please provide details" readonly
                    name="statementOfFact_{{statementOfFact.id}}" [(ngModel)]="statementOfFact.response_text">
            </div>
        </div>
    </div>
    
</form>
<ng-template #content let-modal>
    <div class="modal-body">
        <div [innerHTML]="helptext.replace('[HORSENAME]',this.quote.horse_details.name)"></div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-default btn-gray" (click)="modal.close()">Close</button>
    </div>
</ng-template>